<template>
    <div class="pagination">
        <ul class="pagination__list" v-if="value && max > 1">
            <li
                class="pagination__list__item"
                :class="{ hidden: value <= 1}"
            >
                <router-link :to="toLink(value - 1)" @click.native="selectPage(value - 1)">
                    <font-awesome-icon
                        class="icon"
                        icon="chevron-left"
                    ></font-awesome-icon>
                </router-link>
            </li>

            <li
                class="pagination__list__item white"
                :class="{ hidden: max <= 2 || pages[0] === 1 }"
            >
                <router-link :to="toLink(1)" @click.native="selectPage(1)">1</router-link>
            </li>

            <li
                class="pagination__list__item disabled"
                :class="{ hidden: max <= 2 || pages[0] - 1 <= 0 }"
            >
                ...
            </li>

            <li
                v-for="i in pages"
                :key="i"
                :class="{ active: i === value }"
                class="pagination__list__item white"
            >
                <router-link :to="toLink(i)" @click.native="selectPage(i)">{{ i }}</router-link>
            </li>

            <li
                class="pagination__list__item disabled"
                :class="{
                    hidden: max <= 2 || pages[pages.length - 1] + 1 >= max
                }"
            >
                ...
            </li>

            <li
                class="pagination__list__item white"
                :class="{ hidden: pages[pages.length-1] === max }"
            >
                <router-link :to="toLink(max)" @click.native="selectPage(max)">{{ max }}</router-link>
            </li>

            <li
                class="pagination__list__item"
                :class="{ hidden: value >= max }"
            >
                <router-link :to="toLink(value + 1)" @click.native="selectPage(value + 1)">
                    <font-awesome-icon
                        class="icon"
                        icon="chevron-right"
                    ></font-awesome-icon>
                </router-link>
            </li>
        </ul>
        <div v-if="showPerPage" class="pagination__perpage">
            Показывать
            <select v-model="pageSizeValue" class="pagination__select" @change="updatePageSize">
                <option v-for="pageSizeOption of pageSizeOptions" :key="pageSizeOption" :value="pageSizeOption">{{ pageSizeOption }}</option>
            </select>
        </div>
    </div>
</template>

<script>
import {limitSessions} from "@/stores/examination";

export default {
    props: {
        value: {
            type: Number,
            required: true,
        },
        max: {
            type: Number,
            required: true,
        },
        pageSize: {
            type: Number,
            default: limitSessions,
        },
        showPerPage: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['input', 'inputPageSize'],
    data() {
        return {
            pageSizeValue: this.pageSize,
            pageSizeOptions: [1,2,3,10, 20, 50, 150, 300, 500, 1e3],
        };
    },
    computed: {
        pages() {
            if (this.value === null || this.value > this.max) {
                return [];
            }
            const start = Math.max(1, this.value - 3);
            const end = Math.min(this.max, this.value + 3);
            return [...Array(end-start+1).keys()].map(v => start + v);
        },
        toLink() {
            return (v) => {
                return {
                    name: this.$route.name,
                    params: { page: v, id: this.$route.params.id },
                    query: this.$route.query,
                };
            };
        },
    },
    methods: {
        selectPage(page) {
            if (page >= 1 && page <= this.max) {
                this.$emit('input', page);
            }
        },
        updatePageSize() {
            this.$emit('inputPageSize', this.pageSizeValue);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/rem';
/*activate checkbox regExp in finder of phpStorm*/
/*find      {: ([0-9]*)px}*/
/*replace   {: rem($1);}*/

.pagination {
  text-align: center;
  display: inline-flex;
  align-items: center;
  font-family: 'Montserrat',sans-serif;

  @include on-mobile {
    margin: mrem(32) 0;
  }

  &__list {
    display: inline-block;
    padding: 0;
    margin: 0;
    list-style: none;
    height: 2rem;

    @include on-mobile {
      height: mrem(32);
    }

    &__item {
      cursor: pointer;
      display: inline-block;
      font-weight: 600;
      text-align: center;
      color: #2A2626;
      font-size: 0.75rem;
      vertical-align: middle;
      // padding: 0.625rem 0;
      width: 2rem;
      border-radius: rem(4);

      @include on-mobile {
        width: mrem(32);
        font-size: mrem(12);
        border-radius: mrem(4);
      }

      &.white {
        background-color: white;
      }

      a {
        width: 100%;
        padding: 0.625rem 0;
        display: block;

        @include on-mobile {
          padding: mrem(9) 0;
        }
      }

      &.active {
        background: #4663AB;
        border-bottom: 1px solid #4663AB;
        box-shadow: rem(0) 2px 8px rgba(155, 161, 166, 0.23626);
        cursor: default;

        a {
          color: white;
        }
      }

      &.disabled {
        cursor: default;
      }

      &.hidden {
        display: none;
      }

      &:hover:not(.active):not(.disabled) {
        a, .icon > * {
          color: #4663AB;
        }
      }
    }
  }
  &__perpage {
    margin-left: rem(46);
    font-weight: 400;
    font-size: rem(16);
    line-height: rem(22);
    color: #2A2626;
  }
  &__select {
    padding: rem(12) rem(16);
    border: 1px solid #D2D5D9;
    border-radius: 4px;

    font-family: 'Montserrat';
    font-weight: 400;
    font-size: rem(16);
    line-height: rem(22);
    color: #2A2626;

    option {
      font-style: normal;
      font-weight: 400;
      font-size: rem(16);
      line-height: rem(22);
      color: #2A2626;
    }
  }
}
</style>